import { atom } from 'recoil';
import { UserProductPermission } from '../interfaces/User';

export interface PermissionsListType {
  list: UserProductPermission[] | null;
}

export const PermissionsListState = atom<PermissionsListType>({
  key: 'PermissionsListState',
  default: {
    list: null,
  },
});
